import { useCallback, useEffect, useMemo, useRef } from "react";

import { defaultTQC2050_R01Filter, useTQC2050_R01Store } from "./Store_TQC2050_R01";
import useUiuxStore from "src/store/useUiuxStore";

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { refetchUpdateList } from "src/utils/axios/reFetch";
import { validateString } from "src/utils/string/stringUtil";
import { showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { createTQC2050_R01, deleteTQC2050_R01, downloadExcel_TQC2050_R01, getTQC2050_R01AllCount, getTQC2050_R01Search, patchTQC2050_R01, printTQC2050_R01, getTQC2050_R01One } from "./Api_TQC2050_R01";
import { useQzPrint } from "src/hooks/useQzPrint";
import qz from "qz-tray";
import { defaultTQC2050_R01HeaderDto, TQC2050_R01Dto, TQC2050_R01HeaderDto, TQC2050_R01DetailDto, defaultTQC2050_R01DetailDto } from "./Dto_TQC2050_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from "src/utils/grid/GridHandlerContent";
import { validateCustomCd, validateEmployeeCd } from "src/utils/grid/GridValidateContent";

interface Props {
	gridRef: React.RefObject<AgGridReact<TQC2050_R01HeaderDto> | null>;
	containerRef: React.RefObject<HTMLDivElement | null>;
	
}

export const Content_TQC2050_R01 = (props: Props) => {

	const {
		gridRef,
	} = props;

	useFetchActionbarAuth("TQC2050_R01");
	const { customCdList, employeeCdList, itemCdMap } = useCommonCodeStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	
	const { 
		
		TQC2050_R01List, setTQC2050_R01List, 
		selectedTQC2050_R01,  setSelectedTQC2050_R01, 
		editTQC2050_R01, setEditTQC2050_R01, 
		allCount, setAllCount,
		// Detail 상태
		TQC2050_R01DetailList, deletedTQC2050_R01DetailList,
		setTQC2050_R01DetailList, setDeletedTQC2050_R01DetailList,
		setOriginalTQC2050_R01DetailList,
		// ✅ DetailTable 상태 관리
		setPrevSampleCount, setIsEditing,
		initData,
		setScrollTop, setDetailScrollTop, setDetailScrollTop2,
		} = useTQC2050_R01Store();

	const { 
		TQC2050_R01Filter, setTQC2050_R01Filter,
		TQC2050_R01PastFilter, setTQC2050_R01PastFilter,
	 } = useTQC2050_R01Store();
	const { setMessage } = useUiuxStore();

    const getParams = (filter: { 
        compCd: string, 
        testDt: import('react-day-picker').DateRange | undefined,
        empNo: string, 
        carModel: string, 
        equipmentCd: string 
    }) => {
        const from = filter.testDt?.from ? new Date(filter.testDt.from) : undefined;
        const to = filter.testDt?.to ? new Date(filter.testDt.to) : undefined;
        const format = (d?: Date) => d ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` : '';
        const params = {
            compCd: filter.compCd,
            startDate: format(from),
            endDate: format(to),
            empNo: filter.empNo,
            carModel: filter.carModel,
            equipmentCd: filter.equipmentCd,
            listLength: 0
        }
        return params;
    }

	const renewalAllCount = useCallback(async () => {
		const response = await getTQC2050_R01AllCount(getParams(TQC2050_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [TQC2050_R01Filter, setAllCount])

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
		setDetailScrollTop2(null);

		const { isDefaultFilter, isDefaultPastFilter } = fetchFilterConfig(
			TQC2050_R01Filter,
			TQC2050_R01PastFilter,
			defaultTQC2050_R01Filter,
			TQC2050_R01List.length
		);

        const response = await getTQC2050_R01Search(getParams(TQC2050_R01Filter));
		let newList = [...TQC2050_R01List ]
		newList = fetchDataSetHandler( //newList 내용을 DtoList에 등록
			isDefaultFilter, isDefaultPastFilter,
			response.data.data as TQC2050_R01HeaderDto[],
			TQC2050_R01List, setTQC2050_R01List,
		);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedTQC2050_R01,
				() => true,// () => !newList.find(value => value.itemCd === selectedTQC2050_R01?.itemCd)
			);
			setTQC2050_R01PastFilter(TQC2050_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('조회된 데이터가 없습니다.');
			handleCreateClick();
		}
		setLoadingSpinner(false);

		return response.data.data;
	}, [TQC2050_R01Filter, TQC2050_R01List, gridRef, editTQC2050_R01, setTQC2050_R01List, setSelectedTQC2050_R01, setScrollTop, setDetailScrollTop, setDetailScrollTop2])

	const defaultTQC2050_R01HeaderRow = useCallback(() => {
		return {
			...defaultTQC2050_R01HeaderDto,
			inserted: true,
		}
	}, [defaultTQC2050_R01HeaderDto]);

	const defaultTQC2050_R01DtlRow = useCallback(() => {
		return {
			...defaultTQC2050_R01DetailDto,
			inserted: true,
		}
	}, [defaultTQC2050_R01DetailDto]);

	const fetchOne = useCallback(async () => {
		if (!selectedTQC2050_R01) return;

		const response = await getTQC2050_R01One(selectedTQC2050_R01.testResultNo);
		const apiData = response.data.data;

		// ✅ 1단계: API 응답의 testDetails를 TQC2050_R01DetailList로 변환 (단일 소스 원칙)
		if (apiData.testDetails && apiData.testDetails.length > 0) {
			// testDetails를 TQC2050_R01DetailList로 변환
			const detailList = apiData.testDetails.map((detail: TQC2050_R01DetailDto, index: number) => ({
				...detail,
				inserted: false,  // ✅ 저장된 데이터는 신규 행이 아님
			    isModified: false,  // ✅ 저장된 데이터는 수정되지 않음
			}));
			
			setTQC2050_R01DetailList(detailList);
			setOriginalTQC2050_R01DetailList(detailList);
		} else {
			// testDetails가 없으면 빈 리스트로 설정
			setTQC2050_R01DetailList([]);
			setOriginalTQC2050_R01DetailList([]);
		}

		setEditTQC2050_R01({
			...defaultTQC2050_R01HeaderRow,
			...apiData,
		});
	}, [selectedTQC2050_R01, setEditTQC2050_R01, setTQC2050_R01DetailList, setOriginalTQC2050_R01DetailList, defaultTQC2050_R01HeaderRow])

	// Info 저장 전 유효성 검사
	// ✅ Zustand 스토어에서 최신 값을 직접 참조하도록 수정 (오래된 클로저 문제 해결)
	const validateInsertData = (data: TQC2050_R01HeaderDto | null): { isValid: boolean; message?: string } => {
		if (!data) return { isValid: false, message: '시험 정보를 선택하세요.' };

		// 필수값 체크
		if (!validateString(data.testNm)) return { isValid: false, message: '시험명을 입력하세요.' };
		if (!validateString(data.itemNo) || !validateString(data.itemNm)) return { isValid: false, message: '품목코드를 선택하세요.' };
		if (!validateString(data.empNo) || !validateString(data.empNm)) return { isValid: false, message: '시험자를 선택하세요.' };

		if (!validateString(data.customCd)) return { isValid: false, message: '고객사를 선택하세요.' };
		if (!validateCustomCd(data.customCd, customCdList)) return { isValid: false, message: '고객사가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)' };
		if (!validateString(data.empNo)) return { isValid: false, message: '담당자를 선택하세요.' };
		if (!validateEmployeeCd(data.empNo, employeeCdList)) return { isValid: false, message: '담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)' };

		if(validateString(data.itemNo) && !itemCdMap.has(data.itemNo)) {
			return { isValid: false, message: '품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + data.itemNo };
		}

		// 시료수
		if ((data.sampleCount ?? 0) <= 0) return { isValid: false, message: '시료수를 1 이상으로 입력하세요.' };

		// ✅ 디테일 행 검증: Zustand 스토어에서 최신 값을 직접 참조
		const storeState = useTQC2050_R01Store.getState();
		const currentDetailList = storeState.TQC2050_R01DetailList || [];
		const currentDeletedList = storeState.deletedTQC2050_R01DetailList || [];
		
		const deletedSet = new Set(currentDeletedList.map(v => String(v)));
		const activeDetails = currentDetailList.filter(d => !deletedSet.has(String(d.valueIndex)));
		if (activeDetails.length !== data.sampleCount) {
			return { isValid: false, message: `시료수(${data.sampleCount})와 디테일 행 수(${activeDetails.length})가 일치하지 않습니다.` };
		}
		const missing = activeDetails.filter(d => !validateString(d.sampleInfo) || !validateString(d.testValue));
		// if (missing.length > 0) {
		// 	return { isValid: false, message: '모든 디테일 행의 시료/시험결과를 입력하세요.' };
		// }

		return { isValid: true };
	}

	const handleExcelClick = useCallback(async () => {
		setLoadingSpinner(true);

		const { isDefaultFilter, isDefaultPastFilter, listLength } = fetchFilterConfig(
			TQC2050_R01Filter,
			TQC2050_R01PastFilter,
			defaultTQC2050_R01Filter,
			TQC2050_R01List.length
		);

        const response = await downloadExcel_TQC2050_R01(getParams(TQC2050_R01Filter));

		downloadSettingExcel({ responseData: response.data.data, fileName: '시험성적결과 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [TQC2050_R01Filter, TQC2050_R01List, setLoadingSpinner])

	const handlePrintClick = useCallback(async () => {
		if (!selectedTQC2050_R01) {
			showWarning('인쇄할 시험 결과를 선택하세요.');
			return;
		}

		setLoadingSpinner(true);
		try {
			const response = await printTQC2050_R01(selectedTQC2050_R01.testResultNo);
			const blob = new Blob([response.data], { type: 'application/pdf' });

			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, 'report1');
				if (ok) {
					showSuccess('시험성적서가 인쇄되었습니다.');
				} else {
					const fileURL = URL.createObjectURL(blob);
					const win = window.open(fileURL, '_blank');
					if (win) win.addEventListener('load', () => win.print());
					showWarning('QZ로 출력할 수 없어 브라우저 인쇄 창을 띄웁니다.');
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, '_blank');
				showSuccess('시험성적서 PDF를 새 탭에서 열었습니다.');
			}
		} catch (error) {
			console.error('인쇄 실패:', error);
			showWarning('시험성적서 인쇄에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedTQC2050_R01, printPdfFromBlob, setLoadingSpinner]);

	
    const initContainerData = useCallback(() => {
		initData();
    }, [initData]);

    const handleDeleteClick = useCallback(async () => {
		if (!selectedTQC2050_R01) {
			showWarning('선택된 품목이 없습니다.'); return;
		}
		if (window.confirm('정말로 삭제하시겠습니까?')) {
            await deleteTQC2050_R01(selectedTQC2050_R01.testResultNo);
            refetchUpdateList('delete', selectedTQC2050_R01, selectedTQC2050_R01, 'testResultNo', TQC2050_R01List, setTQC2050_R01List);
			handleCreateClick();
            showSuccess(`${selectedTQC2050_R01.testResultNo} 시험 삭제가 완료되었습니다.`)
		}

	}, [selectedTQC2050_R01]);

	const handleCreateClick = useCallback(async () => {
		// initItemData();
		setSelectedTQC2050_R01(undefined);
		setEditTQC2050_R01({...defaultTQC2050_R01HeaderRow(), sampleCount: 1});
		setTQC2050_R01DetailList([{...defaultTQC2050_R01DtlRow()}]);
		setOriginalTQC2050_R01DetailList([]);
		setDeletedTQC2050_R01DetailList([]);
		setPrevSampleCount(undefined);
		setIsEditing(false);
	}, []);

	const handleSaveClick = useCallback(async () => {
        if (!editTQC2050_R01) { 
            showWarning("시험 정보를 선택하세요."); 
            return; 
        }

		// 저장 전 유효성 검사
		const validation = validateInsertData(editTQC2050_R01);
		if (!validation.isValid) {
			if (validation.message) showWarning(validation.message);
			return;
		}


        // 저장 직전 UI에서 직접 값 보정 (드롭다운이 렌더만 되고 상태가 비어있는 경우 대비)
        const carModelSelect = document.querySelector('select[name="carModel"]') as HTMLSelectElement | null;
        const equipmentSelect = document.querySelector('select[name="equipmentCd"]') as HTMLSelectElement | null;

        const uiCarModel = carModelSelect?.value || '';
        const uiEquipmentCd = equipmentSelect?.value || '';
        const uiEquipmentNm = equipmentSelect?.selectedOptions?.[0]?.text || '';

        // ✅ 저장 시 최신 디테일 데이터를 testDetails로 포함
        // TQC2050_R01DetailList를 단일 소스로 사용하므로, 저장 시 명시적으로 testDetails에 포함
        // 백엔드가 testDetails로 받도록 설정되어 있으므로 testDetails로 전송
        const storeState = useTQC2050_R01Store.getState();
        const currentDetailList = storeState.TQC2050_R01DetailList || [];
        const currentDeletedList = storeState.deletedTQC2050_R01DetailList || [];
        
        // 삭제된 행을 제외한 활성 디테일 리스트 생성
        const deletedSet = new Set(currentDeletedList.map(v => String(v)));
        const activeDetailList = currentDetailList.filter(d => !deletedSet.has(String(d.valueIndex)));

        // 오늘 날짜를 ISO 형식으로 생성 (YYYY-MM-DDTHH:mm:ss)
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
        const seconds = String(today.getSeconds()).padStart(2, '0');
        const todayDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        const headerData: TQC2050_R01HeaderDto = {
            ...editTQC2050_R01,
            carModel: editTQC2050_R01.carModel || uiCarModel,
            equipmentCd: editTQC2050_R01.equipmentCd || uiEquipmentCd,
            equipmentNm: editTQC2050_R01.equipmentNm || uiEquipmentNm,
            testFrdt: todayDateTime,
            testTodt: todayDateTime,
            lotNo: editTQC2050_R01.lotNo,
        };
        const payload: TQC2050_R01Dto = {
            tqcTestHeaderDto: headerData,
            tqcTestDetailDtoList: activeDetailList,
        };

        // ✅ 저장 시 전송되는 전체 payload 확인 (1회)
        console.log('[TQC2050_R01 저장] payload:', payload);

        let processName = '';
        let responseData: TQC2050_R01HeaderDto | undefined = undefined;
        try {
            if (selectedTQC2050_R01) {
                processName = 'patch';
                const response = await patchTQC2050_R01(payload);
                if (response && response.data) {
                    if (response.data.successFlag) {
                        responseData = response.data.data || headerData;
                        showSuccess(`${headerData.testResultNo} 시험 수정이 완료되었습니다.`);
                        setMessage(`${headerData.testResultNo} 시험 수정이 완료되었습니다.`);
                    } else {
                        return;
                    }
                }
            } else {
                processName = 'post';
                const response = await createTQC2050_R01(payload);
                if (response && response.data) {
                    if (response.data.successFlag) {
                        if (response.data.data) {
                            responseData = response.data.data;
                            showSuccess(`${responseData.testResultNo} 시험 등록이 완료되었습니다.`);
                            setMessage(`${responseData.testResultNo} 시험 등록이 완료되었습니다.`);
                        } else {
                            // 서버 응답이 없으면 재조회
                            showSuccess('시험 등록이 완료되었습니다.');
                            setMessage('시험 등록이 완료되었습니다.');
                            fetchData(); // 전체 목록 재조회
                            return;
                        }
                    } else {
                        return;
                    }
                }
            }

            if (responseData) {
                // 신규 등록 시 testResultNo가 있는지 확인
                if (processName === 'post' && (!responseData.testResultNo || responseData.testResultNo === '')) {
                    console.warn('신규 등록 시 testResultNo가 없습니다. 리스트 업데이트를 건너뜁니다.');
                    showSuccess('시험 등록이 완료되었습니다.');
                    setTimeout(() => {
                        fetchData(); // 전체 목록 재조회로 문제 해결
                    }, 100);
                    return;
                }
                
                // 신규 등록 시에는 responseData를 itemToUpdate로 사용 (testResultNo가 서버에서 생성됨)
                const itemToUpdate = processName === 'post' ? responseData : headerData;
                refetchUpdateList(processName, responseData, itemToUpdate, 'testResultNo', TQC2050_R01List, setTQC2050_R01List);
                setSelectedTQC2050_R01(responseData);
            } else {
                console.error("저장 후 응답 데이터가 유효하지 않습니다.");
                showWarning("저장 후 응답 데이터가 유효하지 않습니다.");
            }

            setTimeout(() => {
                setMessage("");
            }, 5000);
        } catch (error) {
            console.error("저장 실패:", error);
            showWarning("시험 결과 저장에 실패했습니다.");
        }
	}, [editTQC2050_R01, selectedTQC2050_R01, TQC2050_R01List, setTQC2050_R01List, setSelectedTQC2050_R01, setMessage, fetchData])

	//selectedTQC2050_R01 변경 시 품목 이미지 불러오기
	useEffect(() => {
		if (selectedTQC2050_R01) {
            fetchOne();
		}else{
			setEditTQC2050_R01(defaultTQC2050_R01HeaderRow());
			setTQC2050_R01DetailList([]);
			setOriginalTQC2050_R01DetailList([]);
			setDeletedTQC2050_R01DetailList([]);
			setPrevSampleCount(undefined);
			setIsEditing(false);
		}
	}, [selectedTQC2050_R01])

	return {
		fetchData,
		defaultTQC2050_R01HeaderRow,
		handleExcelClick,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handlePrintClick,
	}
}

